import {
  AbsenceType,
  DayOfWeek,
  VisitCardLineStyleDto,
} from '@lmt/shared-types';
import { startOfDay } from 'date-fns';
import { FC } from 'react';

export const defaultVisitColor = '#748df9';

export type DragObject = {
  title: string;
  iconComponent?: FC;
} & (
  | {
      type: 'patient';
      viewType: 'tab' | 'patient-in-calendar-list';
      patientId: number;
    }
  | {
      type: 'generic-tab';
    }
  | {
      type: 'visit';
      visitId: number;
      visitData: {
        title: string;
        patient: { id: number; fullName: string };
        color: string;
        subtenantCode: string;
        id: number;
        lineStyles: VisitCardLineStyleDto[];
      };
    }
  | CalendarCellDropTarget
);

export type DroppedItemType = 'patient' | 'visit';

export type CalendarCellDropTarget = {
  type: 'calendar-cell';
  startDate: Date;
  endDate: Date;
  resource?: number;
};

export type HolidaysAndAnonimized = {
  id: number;
  startDate: Date;
  endDate: Date;
  resources: number[] | undefined | null;
  isAnonymized: boolean;
  absenceType: AbsenceType | null;
  title: string;
  // we need to manually set `allDay`, because Holidays could be longer than 1 day, but we don't want to move them to `All Day` panel
  allDay: boolean;
};

export function getSecondsFromMidnight(date: Date): number {
  return (date.getTime() - startOfDay(date).getTime()) / 1000;
}

export function convertPresentDaysToExcludedDays(
  presentDays: Array<DayOfWeek>,
): DayOfWeek[] {
  return [...Array(7).keys()].filter((d) => !presentDays.includes(d));
}
